import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHashnodeComponent } from './simple-icons-hashnode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHashnodeComponent ],
    exports:      [ SimpleIconsHashnodeComponent ],
    bootstrap:    []
})
export class SimpleIconsHashnodeModule {}
